import { Box, Avatar } from '@mui/material';
import { styled } from '@mui/system';

export const AboutSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.sectionPrimaryDark || theme.custom?.gradients?.appBackgroundDark || 'linear-gradient(135deg, #121212 0%, #2C3E50 100%)')
    : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 250,
  height: 250,
  border: theme.palette.mode === 'dark'
    ? '4px solid #BB86FC'
    : `4px solid ${theme.palette.primary.main}`,
  boxShadow: theme.palette.mode === 'dark'
    ? (theme.custom?.shadows?.glowPrimary || '0 10px 20px rgba(187, 134, 252, 0.3)')
    : '0 10px 20px rgba(0, 0, 0, 0.1)',
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.bgDark || 'rgba(255, 255, 255, 0.06)')
    : 'rgba(255, 255, 255, 0.8)',
  borderRadius: '15px',
  padding: theme.spacing(4),
  boxShadow: theme.palette.mode === 'dark'
    ? (theme.custom?.shadows?.softDark || '0 5px 15px rgba(0, 0, 0, 0.3)')
    : '0 5px 15px rgba(0, 0, 0, 0.08)',
  border: theme.palette.mode === 'dark' ? (theme.custom?.glass?.borderDark || '1px solid rgba(255,255,255,0.10)') : undefined,
  backdropFilter: theme.palette.mode === 'dark' ? (theme.custom?.glass?.blur || 'blur(14px)') : 'blur(10px)',
}));
